/**
 * API 基础配置
 */

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 60000,
    withCredentials: true,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
});

// 全局响应拦截器
api.interceptors.response.use(
    (response) => response,
    (error) => {
        let errorMessage = '请求失败';

        if (error.response) {
            const status = error.response.status;
            const data = error.response.data;

            if (status === 400) {
                errorMessage = data?.detail || data?.error || '请求参数错误';
            } else if (status === 401) {
                errorMessage = '未授权,请登录';
            } else if (status === 403) {
                errorMessage = '权限不足';
            } else if (status === 404) {
                errorMessage = '请求的资源不存在';
            } else if (status === 500) {
                errorMessage = '服务器内部错误';
            } else {
                errorMessage = data?.detail || data?.error || `请求失败 (${status})`;
            }
        } else if (error.request) {
            errorMessage = '网络连接失败,请检查后端服务是否启动';
        } else {
            errorMessage = error.message || '请求配置错误';
        }

        error.userMessage = errorMessage;
        return Promise.reject(error);
    }
);

export default api;
